module.exports = __webpack_public_path__ + "5a2b4dbd92e09c1e0c126db8e303c027.svg";